var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.routerLink)?[_c('router-link',{staticClass:"button",attrs:{"id":_vm.id,"to":_vm.routerLink}},[_vm._v(_vm._s(_vm.title))])]:[_c('a',{staticClass:"button",attrs:{"id":_vm.id,"href":_vm.url}},[_vm._v(_vm._s(_vm.title))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }